export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ?? 'https://api.targetmap.net/auth'

export const ADMIN_URL =
  process.env.REACT_APP_ADMIN_URL ?? 'https://admin.targetmap.net/main'
export const MAIN_APP_URL =
  process.env.REACT_APP_MAIN_URL ?? 'https://app.targetmap.net/main';
